import {CategoryInterface} from 'shared/components/Product/Category';
import {ItemType} from 'shared/components/Product/Item';

interface Count {
    total: number;
    subCategories: {[key: number]: Count};
}

export const getItemCounts = (items: ItemType[]) => {
    const counts: {[key: number]: Count} = {};

    for (const item of items) {
        const catId = item.style;
        const subId = item.subStyleId;

        if (catId != null || catId != undefined) {
            if (!counts[Number(catId)]) {
                counts[Number(catId)] = {total: 0, subCategories: {}};
            }

            counts[Number(catId)].total += 1;

            if (subId != null || subId != undefined) {
                if (!counts[Number(catId)].subCategories[Number(subId)]) {
                    counts[Number(catId)].subCategories[Number(subId)] = {
                        total: 0,
                        subCategories: {},
                    };
                }

                counts[Number(catId)].subCategories[Number(subId)].total += 1;
            }
        }
    }

    return counts;
};

const getCount = (bucket?: Count): number => bucket?.total ?? 0;

interface SubStyleInterface {
    subStyleId: number;
}

interface CategoryWithSubStyles extends CategoryInterface {
    subStyles?: SubStyleInterface[];
}

export const mapCategories = (
    allCategories: CategoryWithSubStyles[],
    counts: {[key: number]: Count}
): CategoryInterface[] => {
    return allCategories.map((category) => {
        const categoryCounts = counts[category.id];

        const subStyles = category.subStyles?.map((substyle) => ({
            ...substyle,
            productCount: getCount(
                categoryCounts?.subCategories[substyle.subStyleId]
            ),
        }));

        return {
            ...category,
            subStyles: subStyles ?? category.subStyles,
            productCount: getCount(categoryCounts),
        };
    });
};
